const LabMainPage = () => {
  return (
    <div className="powerBiContainer">
      <iframe
        src={`https://app.powerbi.com/view?r=eyJrIjoiMDZhNWNmOGItOTg5MS00YWExLWJhZGItNWU5MDVlZDE2NjFhIiwidCI6IjczM2E0OGI0LTQyYjUtNDM3NC04MDJlLWMzN2U2YzZkNWUwYiIsImMiOjh9&pageName=211471d768d3f2307a40`}
        title={'Lab powerBi'}
        width={'100%'}
        height={'100%'}
        allowFullScreen
        sandbox="allow-same-origin allow-scripts allow-forms"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default LabMainPage;
